function updateFilterButtons(buttons, activeButton) {
    buttons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('__active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
}

function getFilteredSlides(slides, postType) {
    if (postType === 'all') {
        return slides;
    }

    return slides.filter((slide) => slide.dataset.postType === postType);
}

function renderSlides(wrapper, slides) {
    wrapper.replaceChildren(...slides);
}

function updateSwiper(slider) {
    if (!slider?.swiper) {
        return;
    }

    slider.swiper.update();
    slider.swiper.slideTo(0, 0);
}

function initRelatedPostsFilters() {
    document.querySelectorAll('.swiperNewsBlock').forEach((block) => {
        const buttons = Array.from(block.querySelectorAll('[data-related-filter]'));
        const slider = block.querySelector('.swiperNewsSlider');
        const wrapper = block.querySelector('.swiper-wrapper');

        if (!buttons.length || !slider || !wrapper) {
            return;
        }

        const originalSlides = Array.from(wrapper.children);
        if (!originalSlides.length) {
            return;
        }

        buttons.forEach((button) => {
            button.setAttribute('aria-pressed', button.classList.contains('__active') ? 'true' : 'false');

            button.addEventListener('click', () => {
                const postType = button.dataset.postType || 'all';
                const filteredSlides = getFilteredSlides(originalSlides, postType);

                updateFilterButtons(buttons, button);
                renderSlides(wrapper, filteredSlides);
                updateSwiper(slider);
            });
        });
    });
}

window.addEventListener('load', initRelatedPostsFilters);
